module.exports = __webpack_public_path__ + "static/media/CHAP01-TITRE.b8484b20.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skew/img/CHAP01-TITRE.png
// module id = 295
// module chunks = 0